export default "/7ee56fc642439642e071ad6692a1a8b95a874bf4/2cb37da391587709fd85749e116baa74.svg";